(function() {
    'use strict';

    angular
        .module('TR')
        .directive('canonicalTags', canonicalDirective);

    function canonicalDirective(broker, $document, urlUtils) {
        return {
            restrict: 'E',
            link
        };

        function link(scope) {
            broker.subscribe('canonicalDirective', 'seoCanonicalDetected', function(eventData) {
                _.map($document[0].head.getElementsByTagName('link'), function(linkTag) {
                    if (linkTag.rel === 'canonical' || linkTag.rel === 'alternate') {
                        linkTag.href = setCanonicalFid(linkTag.href, eventData.data.fid);
                    }
                });
            });

            scope.$on('$destroy', function() {
                broker.unsubscribe('canonicalDirective');
            });
        }

        // this assumes that a canonical url with a fid will be the path + the single fid parameter
        function setCanonicalFid(targetUrl, fid) {
            const parsedHref = urlUtils.parse(targetUrl);
            return `${parsedHref.url}?fid=${fid}`;
        }
    }
})();
